module.exports = __webpack_public_path__ + "static/media/arrow_right.141d9197.svg";